import { render, staticRenderFns } from "./Snippet.vue?vue&type=template&id=8fd826e6&scoped=true"
import script from "./Snippet.vue?vue&type=script&lang=js"
export * from "./Snippet.vue?vue&type=script&lang=js"
import style0 from "./Snippet.vue?vue&type=style&index=0&id=8fd826e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd826e6",
  null
  
)

export default component.exports